import React from 'react'
import cn from 'classnames'

function supplySizeConfigurationForGhost(imageUrl, size = 1) {
  if (!/ghost/.test(imageUrl)) {
    return imageUrl
  }

  const regEx = /(?<rootPart>.*)\/content\/images\/(?<imgPart>.*)/
  const components = regEx.exec(imageUrl)

  const imgSize = `w${300 * size}`
  return `${components.groups.rootPart}/content/images/size/${imgSize}/${components.groups.imgPart}`
}

export const WildImage = ({
  imgSrc,
  imgSlug,
  className,
  size,
}: {
  imgSrc: string
  imgSlug: string
  className?: string
  size: 'large' | 'small'
}) => {
  return (
    <a
      href={`/blog/${imgSlug}`}
      className={`${cn({
        'h-[100vw] md:h-full': size === 'large',
        'h-[47vw] md:h-full': size === 'small',
      })} ${className}`}
    >
      <img
        className={`rounded-xl object-cover h-full w-full`}
        src={supplySizeConfigurationForGhost(imgSrc, size === 'large' ? 2 : 1)}
        loading="lazy"
      />
    </a>
  )
}

export function WildImageMobile({ imgSrc, imgSlug, imageClassName }) {
  return (
    <div className="flex justify-center">
      <a
        href={`/blog/${imgSlug}`}
        className="focus-visible:outline-0 focus:outline-none"
      >
        <img
          className={imageClassName}
          src={supplySizeConfigurationForGhost(imgSrc, 1)}
          loading="lazy"
        />
      </a>
    </div>
  )
}
